import React from "react";

const Bash_Uptime = () => {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">Bash Uptime</h2>
      <p>Show how long the system has been running and load averages.</p>
      <h4 className="font-medium mt-4">Syntax</h4>
      <pre><code>uptime</code></pre>
      <h4 className="font-medium mt-4">Examples</h4>
      <pre><code>uptime</code></pre>
      <h4 className="font-medium mt-4">Notes</h4>
      <p>Useful for quick health checks.</p>
    </div>
  );
};

export default Bash_Uptime;
